const input = require('../input/input');

const textarea = Object.assign({}, input, {
   
});

module.exports = textarea;

